import { useEffect, useState } from "react";
import AdminLayout from "../../../layouts/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllFreelancer,
  fetchAllHireTalent,
  fetchHireTalentDetails,
  fetchCoachies,
  updateCoachStatus,
} from "../../../redux/features/admin/actions/authAction";
import Loader from "../../../components/loader";
import TableHeader from "../../../components/table/tableHeader";
import NoRecord from "../../../components/form/NoRecord";
import ReactPagination from "../../../components/table/ReactPagination";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import CoachDetails from "../../../components/pages/admin/modals/CoachDetails";
import FreelancerDetails from "../../../components/pages/admin/modals/FreelancerDetails";
import EnterpriseDetails from "../../../components/pages/admin/modals/EnterpriseDetails";

const Users = () => {
  const dispatch = useDispatch();
  const [isToggle, setIsToggle] = useState(false);
  const {
    isLoading,
    freelancerList,
    userTabs,
    userTableHeaders,
    usersEventData,
  } = useSelector((state) => state.admin.auth);
  const [isModal, setIsModal] = useState(false);
  const [freelancerDetail, setFreelancerDetail] = useState({});
  const [isFreelancerModal, setIsFreelancerModal] = useState(false);
  const [enterpriseDetail, setEnterpriseDetail] = useState({});
  const [isEnterpriseModal, setIsEnterpriseModal] = useState(false);
  const [activeCoach, setActiveCoach] = useState(null);
  const [activeTab, setActiveTab] = useState("freelancers");

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);

  const paginatedList = usersEventData[activeTab]?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleUpdateStatus = (status, value) => {
    const callback = (response) => {
      dispatch(fetchCoachies());
    };
    let data = {};
    if (status == "APPROVE") {
      data = {
        user_id: value?.user_id,
        status: status,
      };
    } else if (status == "REJECT") {
      data = {
        user_id: value?.user_id,
        status: status,
        rejected_reason: "Please contact admin for more information.",
      };
    }
    dispatch(updateCoachStatus({ payload: data, callback }));
  };

  useEffect(() => {
    dispatch(fetchCoachies());
    dispatch(fetchAllFreelancer());
    dispatch(fetchAllHireTalent());
  }, []);

  const tableBody = (user, index) => {
    switch (activeTab) {
      case userTabs[0].value:
        return (
          <>
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={user?.profile_image || "/assets/img/user_profile.png"}
                    className="ct_img_40"
                  />
                  <div>
                    <h5 className="ct_fs_16 ct_fw_600 mb-1">
                      {user?.full_name ?? ""}
                    </h5>
                    <p className="mb-0 ct_grey_text">{user?.email ?? ""}</p>
                  </div>
                </div>
              </td>
              <td>{user?.email ?? ""}</td>
              <td>
                <span className="ct_overlay_text d-block">
                  {user?.bio ?? ""}{" "}
                </span>
              </td>
              <td>{user?.talent_type == "FREELANCER" ? "Freelancer" : "Job Seeker"}</td>
              <td>
                <a
                  className="ct_right_dropdown text-dark"
                  onClick={() => {
                    setFreelancerDetail(user);
                    setIsFreelancerModal(true);
                  }}
                >
                  <i className="fa-solid fa-eye"></i>
                </a>
              </td>
            </tr>
          </>
        );
      case userTabs[1].value:
        return (
          <>
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <div className="d-flex align-items-center gap-3">
                  <img src={user?.profile_image ?? ""} className="ct_img_40" />
                  <div>
                    <h5 className="ct_fs_16 ct_fw_600 mb-1">
                      {user?.full_name ?? ""}
                    </h5>
                    <p className="mb-0 ct_grey_text">{user?.email ?? ""}</p>
                  </div>
                </div>
              </td>
              <td>{user?.phone_number ?? ""}</td>
              <td>
                <span className="ct_overlay_text d-block">
                  {user?.bio ?? ""}{" "}
                </span>
              </td>
              <td>
                {user?.status == "APPROVE" ? (
                  <span className="ct_publish_badge">Approved</span>
                ) : user?.status == "REJECT" ? (
                  <span className="ct_publish_badge">Rejected</span>
                ) : (
                  <div className="d-flex flex-column gap-2 position-relative">
                    <select
                      className="form-control ct_input border-0 px-0 ct_fit_content"
                      value=""
                      onChange={(e) => handleUpdateStatus(e.target.value, user)}
                    >
                      <option value="">Pending</option>
                      <option value="APPROVE">Approve</option>
                      <option value="REJECT">Reject</option>
                    </select>
                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                  </div>
                )}
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveCoach(user);
                          setIsModal(true);
                        }}
                      >
                        View Profile
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        data-bs-target="#ct_edit_user_info"
                        data-bs-toggle="modal"
                      >
                        Edit User Info
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_yellow_text"
                        data-bs-target="#ct_reactivate_account"
                        data-bs-toggle="modal"
                      >
                        Activate
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_orange_text"
                        data-bs-target="#ct_suspend_account"
                        data-bs-toggle="modal"
                      >
                        Suspend
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        data-bs-target="#ct_remove_user"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case userTabs[2].value:
        return (
          <>
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={user?.profile_image || "/assets/img/user_profile.png"}
                    className="ct_img_40"
                  />
                  <div>
                    <h5 className="ct_fs_16 ct_fw_600 mb-1">
                      {user?.hiretalent?.company_name ?? user?.full_name ?? ""}
                    </h5>
                  </div>
                </div>
              </td>
              <td>{user?.email ?? ""}</td>
              <td>{user?.hiretalent?.primary_contact_full_name ?? "-"}</td>
              {/* <td>
                {user?.status ? (
                  <span className="ct_publish_badge">
                    {user?.status == "APPROVE"
                      ? "Approved"
                      : user?.status == "REJECT"
                        ? "Rejected"
                        : user?.status}
                  </span>
                ) : (
                  "-"
                )}
              </td> */}
              <td>
                <a
                  className="ct_right_dropdown text-dark"
                  onClick={() => {
                    setEnterpriseDetail(user);
                    setIsEnterpriseModal(true);
                    if (user?.user_id) {
                      dispatch(fetchHireTalentDetails(user?.user_id)).then(
                        (res) => {
                          const detail = res?.payload?.data;
                          if (detail) setEnterpriseDetail(detail);
                        }
                      );
                    }
                  }}
                >
                  <i className="fa-solid fa-eye"></i>
                </a>
              </td>
            </tr>
          </>
        );
      default:
        break;
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <AdminLayout>
        <div className="ct_px_40 mt-4">
          <div className="row">
            <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
              <h4 className="mb-0 ct_fs_20 mb-4">Users List</h4>
              <div className="ct_filter_btn">
                <button
                  className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"
                  onClick={() => {
                    setIsToggle(true);
                  }}
                >
                  Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                </button>
              </div>
              <div
                className={`ct_filter_sidebar ct_custom_scroll p-0 ${isToggle ? "show" : ""
                  }`}
              >
                <div
                  className="ct_close_filter d-block d-lg-none"
                  onClick={() => {
                    setIsToggle(false);
                  }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Account Status</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Active
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Suspended
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Pending Approval
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Deactivated
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Activity Level</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last Active: Today
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last 7 Days
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          30+ Days Inactive
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">User Plan</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nuglow
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nuforge
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nustar
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Free
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Others
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Flagged</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Show Only Flagged Users
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-10 col-md-9 mb-4 mb-md-0">
              <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
                <div>
                  <h4 className="mb-0 ct_fs_20 mb-0">Manage Users</h4>
                  <p className="mb-0 ct_text_clr_757886">
                    View, filter, and take action across all Nuvio user types
                  </p>
                </div>
                <div className="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_575">
                  <div className="position-relative ct_w_100_575">
                    <input
                      type="text"
                      className="form-control ct_input ct_h_35 ps-5"
                      placeholder="Search by Title"
                    />
                    <i className="fa-solid fa-search ct_input_icon_left"></i>
                  </div>
                </div>
              </div>
              <div
                className="d-flex align-items-center gap-3 justify-content-between mb-3 ct_flex_col_575 ct_pb_3_575"
                style={{ borderBottom: "1px solid #cccccc" }}
              >
                <ul className="ct_table_filter border-0">
                  <li
                    className={activeTab == "freelancers" && "active"}
                    onClick={() => setActiveTab("freelancers")}
                  >
                    Freelancers (
                    {usersEventData[userTabs[0].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "coaches" && "active"}
                    onClick={() => setActiveTab("coaches")}
                  >
                    Coaches ({usersEventData[userTabs[1].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "enterprises" && "active"}
                    onClick={() => setActiveTab("enterprises")}
                  >
                    Enterprises (
                    {usersEventData[userTabs[2].value]?.length ?? 0})
                  </li>
                  <li>Founders (0)</li>
                  <li>Investors (0)</li>
                </ul>
              </div>
              <div className={`d-block`}>
                <div className="table-responsive ct_custom_table ct_custom_table2 pt-2">
                  <table className="table">
                    <TableHeader data={userTableHeaders[activeTab]} />
                    {paginatedList?.length > 0 && (
                      <tbody>
                        {paginatedList?.map((user, index) =>
                          tableBody(user, index)
                        )}
                      </tbody>
                    )}
                  </table>
                  {paginatedList?.length <= 0 && <NoRecord />}
                </div>
                {paginatedList?.length != 0 && (
                  <div className="d-flex justify-content-between align-items-center mt-4 mb-4 ">
                    <div>
                      <PaginationDropdown
                        onChange={(val) => {
                          setListPerPages(val);
                          setCurrentPage(0);
                        }}
                      />
                    </div>
                    <div>
                      <ReactPagination
                        pageCount={Math.ceil(
                          usersEventData[activeTab]?.length / listPerPages
                        )}
                        onPageChange={handlePageClick}
                        currentPage={currentPage}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <!--  Edit user modal S --> */}
        <div
          className="modal fade modal-lg"
          id="ct_edit_user_info"
          tabindex="-1"
          aria-labelledby="ct_edit_user_infoLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-0">
                <h4 className="mb-1 ct_fs_20 px-4">Edit User Information</h4>
                <p className="mb-0 ct_grey_text px-4">
                  Update basic details for this user
                </p>
                <form className="mt-4 ct_modal_scroll ct_custom_scroll">
                  <div className="row px-4">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="e.g. Alex Brown"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control ct_input"
                          placeholder="e.g. alexbrown@gmail.com"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="e.g. 23478649"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Location{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Los Angeles</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Role{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Freelancer</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Status{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Active</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Verification Status
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Verified</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Admin Notes (optional)
                        </label>
                        <textarea
                          className="form-control ct_input h-auto"
                          rows="4"
                          placeholder="@NuvioTemp123  "
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                    <button
                      className="ct_yellow_btn ct_outline_grey px-5 py-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className="ct_yellow_btn px-5 py-2"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_changed_saved_modal"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Edit user modal E --> */}

        {/* <!-- add admin modal S --> */}
        <div
          className="modal fade modal-lg"
          id="ct_create_admin"
          tabindex="-1"
          aria-labelledby="ct_create_adminLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-0">
                <h4 className="mb-1 ct_fs_20 px-4">Add New Admin</h4>
                <p className="mb-0 ct_grey_text px-4">
                  Invite a new team member and assign their access level
                </p>
                <form
                  action="javascript:void(0)"
                  className="mt-4 ct_modal_scroll ct_custom_scroll"
                >
                  <div className="row px-4">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="e.g. Alex Brown"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control ct_input"
                          placeholder="e.g. alexbrown@gmail.com"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Access Type{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Content Admin</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Status{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option value="">Active</option>
                            <option value="">Deactive</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Temporary Password
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="@NuvioTemp123  "
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label for="" className="d-block mb-2">
                          Confirm Password{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="@NuvioTemp123  "
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                    <button className="ct_yellow_btn ct_outline_grey px-5 py-2">
                      Cancel
                    </button>
                    <button
                      className="ct_yellow_btn px-5 py-2"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_submit_modal"
                    >
                      Invite
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- add admin modal E --> */}
        {/* <!-- admin added modal S --> */}

        {/* <!-- Coach Details Modal--> */}
        <CoachDetails
          isModal={isModal}
          setIsModal={setIsModal}
          data={activeCoach}
        />

        {/* <!-- Freelancer Details Modal--> */}
        <FreelancerDetails
          isModal={isFreelancerModal}
          setIsModal={setIsFreelancerModal}
          data={freelancerDetail}
        />

        {/* <!-- Enterprise Details Modal--> */}
        <EnterpriseDetails
          isModal={isEnterpriseModal}
          setIsModal={setIsEnterpriseModal}
          data={enterpriseDetail}
        />

        {/* <!-- Profile detail modal E --> */}

        <div
          className="modal fade ct_submit_modal"
          id="ct_submit_modal"
          tabindex="-1"
          aria-labelledby="ct_submit_modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Admin Added</h4>
                  <p>
                    The new admin account has been successfully created and
                    granted access to the Nuvio admin Dashboard
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button className="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                    Go to Admin List
                  </button>
                  <button
                    className="ct_yellow_btn ct_h_48 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Add Another Admin
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- admin added modal E --> */}

        {/* Reactive account S */}
        <div
          className="modal fade ct_reactivate_account"
          id="ct_reactivate_account"
          tabindex="-1"
          aria-labelledby="ct_reactivate_accountLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Reactivate User Account</h4>
                  <p>
                    Are you sure you want to reactivate Alex Brown’s account?
                    This will restore her access to the platform
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    className="ct_yellow_btn ct_h_48 px-5 ct_w_100_575 w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_Reactivate_User_success "
                  >
                    Reactivate User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Reactive account E */}

        {/* reactive success account S */}
        <div
          className="modal fade ct_Reactivate_User_success"
          id="ct_Reactivate_User_success"
          tabindex="-1"
          aria-labelledby="ct_Reactivate_User_successLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">
                    User Account Reactivated Successfully
                  </h4>
                  <p>
                    Alex Brown now has full access to her dashboard and
                    activities
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    className="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575"
                    data-bs-target="#ct_profile_modal"
                    data-bs-toggle="modal"
                  >
                    View Profile
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* reactive success account E */}

        {/* changed saved S */}
        <div
          className="modal fade ct_changed_saved_modal"
          id="ct_changed_saved_modal"
          tabindex="-1"
          aria-labelledby="ct_changed_saved_modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Changes Saved</h4>
                  <p>
                    Your user’s information has been updated successfully. All
                    changes are now live on the platform
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* changed saved E */}
        {/* suspend Modal S */}
        <div
          className="modal fade ct_suspend_account"
          id="ct_suspend_account"
          tabindex="-1"
          aria-labelledby="ct_suspend_accountLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                      fill="#023047"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Suspend User Account</h4>
                  <p>
                    Are you sure you want to suspend{" "}
                    <span className="ct_orange_text">Nuray Aksoy</span> account?
                    This will temporarily restrict access to her account on
                    Nuvio.
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button className="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn">
                    Suspend
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* suspend Modal E */}

        {/* user Delete S */}
        <div
          className="modal fade ct_remove_user"
          id="ct_remove_user"
          tabindex="-1"
          aria-labelledby="ct_remove_userLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                      fill="#023047"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Permanently Remove User</h4>
                  <p>
                    You are about to permanently delete{" "}
                    <span className="ct_orange_text">Nuray Aksoy</span> account
                    from the Nuvio platform. This action cannot be undone.
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    className="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn"
                    data-bs-target="#ct_remove_user_success"
                    data-bs-toggle="modal"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* user Delete E */}

        {/* rempove user S */}
        <div
          className="modal fade ct_remove_user_success"
          id="ct_remove_user_success"
          tabindex="-1"
          aria-labelledby="ct_remove_user_successLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">User Removed Successfully</h4>
                  <p>
                    All associated data and access have been deleted from the
                    platform
                  </p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* rempove user E */}

        {/* Approve user S */}
        <div
          className="modal fade ct_approve_user_acount2"
          id="ct_approve_user_acount2"
          tabindex="-1"
          aria-labelledby="ct_approve_user_acount2Label"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">Approve User Account</h4>
                  <p>Are you sure you want to approve Alex Brown account?</p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    className="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575"
                    data-bs-target="#ct_user_remove_sucess"
                    data-bs-toggle="modal"
                  >
                    Approve Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Approve user E */}
        {/* user remove sucess S */}
        <div
          className="modal fade ct_user_remove_sucess"
          id="ct_user_remove_sucess"
          tabindex="-1"
          aria-labelledby="ct_user_remove_sucessLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body py-5">
                <div className="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div className="text-center">
                  <h4 className="ct_fs_20">User Approved</h4>
                  <p>User account approved successfully</p>
                </div>
                <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    className="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* user remove sucess E */}
      </AdminLayout>
    </>
  );
};

export default Users;
